import { AxiosInstance } from 'axios';
import ShiftTypeRepositoryInterface, { ApiCreateShiftTypeInterface, ShiftTypeInterface } from '@/services/Calendar/ShiftType/Interfaces';

export default class ShiftTypeRepository implements ShiftTypeRepositoryInterface {
  private apiPrefix = '/calendar/shifts/type';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllShiftTypes(): Promise<ShiftTypeInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getShiftType(id: string): Promise<ShiftTypeInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/${id}`);

    return res.data;
  }

  public async createShiftType(data: ApiCreateShiftTypeInterface): Promise<boolean> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.status === 201;
  }

  public async deleteShiftType(id: number): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { id } });
  }

  public async updateShiftType(id: string, data: ApiCreateShiftTypeInterface): Promise<void> {
    await this.axios.patch(`${this.apiPrefix}/${id}`, data);
  }

  public calculateShiftDuration(start: string, end: string, breakDuration: number): number {
    let dayWorkingHours: number = 0;
    let nightWorkingHours: number = 0;
    let duration: number = 0;
    let hours: number = 0;
    let minutes: number = 0;

    if (start !== '' && end !== '') {
      const startAt = this.convertTimeToDate(start);
      const endAt = this.convertTimeToDate(end);

      if (start >= end) {
        endAt.setDate(endAt.getDate() + 1);
      }

      const difference = this.differenceBetweenHours(startAt.getTime(), endAt.getTime());
      hours = Math.floor(difference / 60);
      minutes = difference % 60;

      [...Array(hours + (minutes === 30 ? 1 : 0))].fill(0).forEach((value, index) => {
        let hour = startAt.getHours() + 1 + index;

        if (hour > 23) {
          hour -= 24;
        }

        if (hour > 6 && hour < 23) {
          dayWorkingHours += 1;
        } else {
          nightWorkingHours += 1;
        }
      });

      duration = dayWorkingHours + ((nightWorkingHours * 8) / 7) - (minutes === 30 ? 0.5 : 0);

      if (breakDuration) {
        duration -= breakDuration / 60;
      }

      return duration;
    }

    return  0;
  }

  private convertTimeToDate(time: string): Date {
    const [hours, minutes] = time.split(':');
    const date = new Date();

    date.setHours(Number(hours), Number(minutes));

    return date;
  }

  private differenceBetweenHours(start: number, end: number): number {
    const difference = end - start;

    return difference / 60 / 1000;
  }
}
